import { render } from "./ContentAddons.vue?vue&type=template&id=3a5943ba"
import script from "./ContentAddons.vue?vue&type=script&lang=js"
export * from "./ContentAddons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__